import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { PerfectScrollbarModule } from '@farris/ui-perfect-scrollbar';
import { AngularDraggableModule } from '@farris/ui-draggable';
import { ModalModule } from '@farris/ui-modal';

import { DialogComponent } from './dialog/dialog.component';
import { DialogService } from './dialog.service';

@NgModule({
  declarations: [
    DialogComponent
  ],
  imports: [
    PerfectScrollbarModule,
    AngularDraggableModule,
    ModalModule,
    CommonModule,
  ],
  exports: [
    DialogComponent,
    ModalModule
  ]
})
export class FarrisDialogModule {
  static forRoot(): ModuleWithProviders {
    return {
        ngModule: FarrisDialogModule,
        providers: [
            DialogService
        ]
    };
  }
}
